// Idea taken from https://redux.js.org/recipes/structuring-reducers/refactoring-reducers-example#combining-reducers-by-slice
// Basically each entity (company, terminal etc.) is structured to under one reducer. So when there will be more reducers, those
// just will be added to initialState and slide reducer.

import {LOAD_TERMINALS_REQUEST, LOAD_TERMINALS_SUCCESS, LOAD_TERMINALS_FAILURE, ADD_TERMINAL_REQUEST, TERMINALS_EDIT_TERMINAL,
     TERMINALS_DELETE_TERMINAL, DELETE_TERMINALS_REQUEST,DELETE_TERMINAL_FAILURE_CLEAR} from '../actions/actionTypes';
import {createReducer, updateObject} from './reducerUtilities';

const initialState = {
    terminals: {
        terminalsData: null,
        isLoading: false,
        hasFailed: false,
        isDeleting: false,
        deleteHasFailed: false
    },
};


// Slice reducer
export const terminalReducer = createReducer(initialState, {
    [LOAD_TERMINALS_REQUEST] : loadTerminalsRequest,
    [LOAD_TERMINALS_SUCCESS] : loadTerminalsSuccess,
    [LOAD_TERMINALS_FAILURE] : loadTerminalsFailure,
    [ADD_TERMINAL_REQUEST] : addTerminalRequest,
    [TERMINALS_EDIT_TERMINAL] : editTerminal,
    [DELETE_TERMINALS_REQUEST] : deleteTerminalsRequest,   
    [TERMINALS_DELETE_TERMINAL] : deleteTerminal,
    [DELETE_TERMINAL_FAILURE_CLEAR] : clearDeleteTerminalsFailure
});



// -----------------------------------------------------------------------
// LOAD COMPANIES
// -----------------------------------------------------------------------


// Case reducer
function loadTerminalsRequest(state, action) {
    return {...state, terminals: updateObject(
        state.terminals, { 
            isLoading: true 
        })};
}

// Case reducer
function loadTerminalsSuccess(state, action) {   
    return {...state, terminals: updateObject(
        state.terminals, { 
            terminalsData: action.payload.terminals, 
            isLoading: false 
        })};
}

// Case reducer
function loadTerminalsFailure(state, action) {
    return {...state, terminals: updateObject(
        state.terminals, { 
            terminalsData: [], 
            isLoading: false, 
            hasFailed: true 
        })};
}


function addTerminalRequest(state, action) {
    return {...state, terminals: updateObject(
        state.terminals, { 
            terminalsData: [...state.terminals.terminalsData, action.data]
        })};    
}

function editTerminal(state, action) {
    return {...state, terminals: updateObject(
        state.terminals, { 
            terminalsData: state.terminals.terminalsData.map(c => c.id === action.data.id ? action.data : c)
        })}; 
}

// Case reducer
function deleteTerminalsRequest(state, action) {
    return {...state, terminals: updateObject(
        state.terminals, { 
            isDeleting: action.data
        })};
}

function deleteTerminal(state, action) {
    let newTerminals = state.terminals.terminalsData;
    const indx = newTerminals.findIndex(t => t.id === action.data);
    if(indx > -1) {
        newTerminals.splice(indx, 1);
    }
    return {...state, terminals: updateObject(
        state.terminals, {
            terminalsData: newTerminals
        }
    )}
}

// Case reducer
function clearDeleteTerminalsFailure(state, action) {
    return {...state, terminals: updateObject(
        state.terminals, { 
            isDeleting: false, 
            deleteHasFailed: false 
        })};
}
// -----------------------------------------------------------------------
// TODO
// -----------------------------------------------------------------------



// WEBPACK FOOTER //
// ./src/reducers/terminalReducer.js